export const environment = {
  production: true,
  environment: 'PROD',
  version: '1.1.23',
  commitSha: '57e52c9b',
  UpsApiEndpoint: 'https://upservice.legrand.com/',
  EliotApiEndpoint: 'https://upservice.legrand.com/',
  eliot_ocp_key: 'ac9f9c0ffcb94e959062160efb6058ac',
  ups_ocp_key: '378d45106b0743b49d3e88c8193c151a',
  profileWebviewUrl: 'https://myconnectedaccount.legrand.com/',
  firebaseConfig: {
    apiKey: 'AIzaSyAF9aggxa0Uef41bk0FEruEAKPhdlgRz-k',
    authDomain: 'upservice-legrand.firebaseapp.com',
    projectId: 'upservice-legrand',
    storageBucket: 'upservice-legrand.appspot.com',
    messagingSenderId: '548145135865',
    appId: '1:548145135865:web:3794bbbf643f195226e228',
    measurementId: 'G-VY77BK72NM',
  },
  codeAuth: {
    clientId: 'a2008729-1868-41d2-aaee-3190001d29bd',
    responseType: 'code',
    redirectUri: 'https://upservice.legrand.com/login',
    loginUrl:
      'https://login.eliotbylegrand.com/0d8816d5-3e7f-4c86-8229-645137e0f222/oauth2/v2.0/authorize?p=B2C_1A_UpServiceWeb',
    clientSecret: 'no_need',
    timeoutFactor: 300000,
    scope:
      'openid offline_access https://EliotCloudUAMPRD.onmicrosoft.com/security/access.full',
  },
  tokenAuth: {
    clientId: 'a2008729-1868-41d2-aaee-3190001d29bd',
    responseType: 'token',
    tokenEndpoint:
      'https://login.eliotbylegrand.com/0d8816d5-3e7f-4c86-8229-645137e0f222/oauth2/v2.0/token?p=B2C_1A_UpServiceWeb',
    grantType: 'authorization_code',
    clientSecret: 'no_need',
  },
  logOutUrl:
    'https://login.eliotbylegrand.com/0d8816d5-3e7f-4c86-8229-645137e0f222/oauth2/v2.0/logout?p=B2C_1A_UpServiceWeb',
  logoutRedirectUri: 'https://upservice.legrand.com/prelogin',
  storage: {
    accessToken: 'UPService-access-token',
    sasToken: 'UPService-sas-token',
    idToken: 'UPService-id-token',
    refreshToken: 'UPService-refresh-token',
    tokenExpiresIn: 'UPService-expires-in',
    eliotUser: 'UPS-EliotUser',
    searchHistory: 'UPService-search-history',
    upsUser: 'UPS-UpsUser',
    upsBackofficeLanguages: 'UPService-backoffice-languages',
    upsSelectedDocument: 'UPService-selected-document',
    settingsDateFormat: 'UPService-date-format',
    articleCodes: 'UPService-article-codes',
    selectedArticleCode: 'UPService-selected-article-code',
    agenda: 'UPService-agenda',
    news: 'UPService-news',
  },
};
